import {createApiCall} from '../utils';
import {SERVICE_NAMES} from '../constants';
import type {
    ApiCallOptions,
    LayoutsListResponse,
    LayoutApiResponse,
    LayoutsListParams,
    CreateLayoutRequest,
    UpdateLayoutRequest,
    ApplyLayoutRequest
} from './api.d';

export const getLayouts = (params?: LayoutsListParams, options: ApiCallOptions = {}) =>
    createApiCall<LayoutsListResponse>(SERVICE_NAMES.LAYOUT, 'GET', 'layouts')({...options, params});

export const createLayout = (data: CreateLayoutRequest, options: ApiCallOptions = {}) =>
    createApiCall<LayoutApiResponse>(SERVICE_NAMES.LAYOUT, 'POST', 'layouts')({...options, data});

export const updateLayout = (layoutId: string, data: UpdateLayoutRequest, options: ApiCallOptions = {}) =>
    createApiCall<LayoutApiResponse>(SERVICE_NAMES.LAYOUT, 'PUT', `layouts/${layoutId}`)({...options, data});

export const applyLayoutToDocument = (layoutId: string, data: ApplyLayoutRequest, options: ApiCallOptions = {}) =>
    createApiCall<void>(SERVICE_NAMES.LAYOUT, 'POST', `layouts/${layoutId}`)({...options, data});

export const deleteLayout = (layoutId: string, options: ApiCallOptions = {}) =>
    createApiCall<void>(SERVICE_NAMES.LAYOUT, 'DELETE', `layouts/${layoutId}`)({...options});

export const layoutApi = {
    getLayouts,
    createLayout,
    updateLayout,
    applyLayout: applyLayoutToDocument,
    deleteLayout
};
